'use client';

import { useSession } from 'next-auth/react';

export const useIsAuthorizated = () => {
  const session = useSession();
  return {
    isAuthorizated: session.status === 'authenticated',
    isPending: session.status === 'loading',
  };
};
